package org.example.project.screens_cus

import androidx.compose.runtime.Composable
import org.example.project.dashboard.CusBereichWrapper

@Composable
fun CusInfrastrukturDashboard() {
    CusBereichWrapper("InfrastrukturDashboard")
}
